__turbopack_context__.v({
  "member-card": "member-card-module-scss-module__e1ursa__member-card",
  "member-card__badge": "member-card-module-scss-module__e1ursa__member-card__badge",
  "member-card__company-name": "member-card-module-scss-module__e1ursa__member-card__company-name",
  "member-card__designations": "member-card-module-scss-module__e1ursa__member-card__designations",
  "member-card__details": "member-card-module-scss-module__e1ursa__member-card__details",
  "member-card__level-label--sr-only": "member-card-module-scss-module__e1ursa__member-card__level-label--sr-only",
  "member-card__name": "member-card-module-scss-module__e1ursa__member-card__name",
  "member-card__photo": "member-card-module-scss-module__e1ursa__member-card__photo",
  "member-card__photo-container": "member-card-module-scss-module__e1ursa__member-card__photo-container",
});
